import React from 'react';

import { EditableCanvas } from '@wp-block-builder/blocks/Container/ContainerEditableBlock';
import { type TTemplate } from '@wp-block-builder/package';
import { WaypointDocumentStoreProvider } from '@wp-block-builder/stores/WaypointDocumentStore';

import BodyWrapper from '../document-layout/BodyWrapper';
import CanvasBlock from '../document-layout/CanvasBlock';
import GlobalSharedStyle from '../document-layout/GlobalSharedStyle';

import EditableBlock from './Block';
import SelectBlockTypeMenu from './components/AddBlockButton/SelectBlockTypeMenu';
import LayoutHandler from './components/LayoutHandler';
import TuneMenu from './components/TuneMenu';

type TProps = {
  configuration: TTemplate;
  layoutConfiguration: null | TTemplate;
  variables: Record<string, unknown>;
};
export default function EditableMessage({ configuration, layoutConfiguration, variables }: TProps) {
  const renderCanvasBody = () => {
    const layoutBlocks = layoutConfiguration?.blocks;
    const body = <EditableCanvas blocksArrayName="configuration.blocks" BlockComponent={EditableBlock} />;
    if (!layoutBlocks) {
      return body;
    }
    return (
      <LayoutHandler variables={variables} layoutBlocks={layoutBlocks}>
        {body}
      </LayoutHandler>
    );
  };
  return (
    <WaypointDocumentStoreProvider
      skipLiquid={false}
      variables={variables}
      configuration={configuration}
      layoutConfiguration={layoutConfiguration}
    >
      <BodyWrapper stretchBackground>
        <GlobalSharedStyle />
        <TuneMenu />
        <SelectBlockTypeMenu />
        <CanvasBlock>{renderCanvasBody()}</CanvasBlock>
      </BodyWrapper>
    </WaypointDocumentStoreProvider>
  );
}
